import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Select from "react-select";
import Sidebar from "../component/Sidebar";
import Cookies from "js-cookie";

const API_URL =
  "https://hotfix-back-hris.talentfort.live/employeepayments/report";

const monthOrder = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const columns = [
  ["empNo", "Emp No"],
  ["epfNo", "EPF No"],
  ["fullName", "Emp Name"],
  ["salary", "Basic Salary"],
  ["budAllowance", "Bud. Allowance"],
  ["consolidateSalary", "Consolidate Salary"],
  ["nopayRate", "Nopay Rate"],
  ["nopayAmount", "Nopay Amount"],
  ["salaryArrears", "Salary Arrears"],
  ["grossAmount", "Gross Salary"],
  ["overtimeAllowance", "OT Allowance"],
  ["dotAllowance", "DOT Allowance"],
  ["totalPerformanceAllowance", "Performance Allowance"],
  ["salesCommission", "Sales Commission"],
  ["totalotherAllowance", "Other Allowance"],
  ["totalAllowance", "Total Allowance"],
  ["totalEarning", "Total Earning"],
  ["totalDeduction", "Total Deduction"],
  ["netSalary", "Net Salary"],
  ["bankCode", "Bank Code"],
  ["branchCode", "Branch Code"],
  ["accountNo", "Account No"],
];

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    background: "#f3f6fb",
    color: "#111827",
  },
  content: {
    width: "calc(100% - 245px)",
    marginLeft: "245px",
    padding: "22px",
  },
  topbar: {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "16px",
    padding: "18px 20px",
    display: "flex",
    justifyContent: "space-between",
    gap: "16px",
    alignItems: "center",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
    marginBottom: "14px",
  },
  title: {
    margin: 0,
    fontSize: "22px",
    fontWeight: 800,
    color: "#111827",
  },
  subtitle: {
    margin: "5px 0 0",
    fontSize: "13px",
    color: "#6b7280",
  },
  actionGroup: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(160px, 1fr))",
    gap: "12px",
    marginBottom: "14px",
  },
  summaryCard: {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "14px",
    padding: "14px 16px",
    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.05)",
  },
  summaryLabel: {
    display: "block",
    fontSize: "12px",
    color: "#64748b",
    fontWeight: 700,
    marginBottom: "6px",
  },
  summaryValue: {
    fontSize: "20px",
    color: "#111827",
    fontWeight: 800,
  },
  card: {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
  },
  filterCard: {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
    padding: "18px",
    marginBottom: "14px",
  },
  filterHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "14px",
  },
  sectionTitle: {
    margin: 0,
    fontSize: "16px",
    fontWeight: 800,
    color: "#111827",
  },
  sectionSub: {
    margin: "4px 0 0",
    fontSize: "12px",
    color: "#64748b",
  },
  filterGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(180px, 1fr))",
    gap: "12px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  label: {
    fontSize: "12px",
    fontWeight: 800,
    color: "#374151",
  },
  select: {
    width: "100%",
    height: "36px",
    border: "1px solid #d1d5db",
    borderRadius: "9px",
    padding: "0 10px",
    fontSize: "13px",
    background: "#ffffff",
    color: "#111827",
    outline: "none",
  },
  filterActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "8px",
    marginTop: "14px",
    paddingTop: "12px",
    borderTop: "1px solid #f1f5f9",
  },
  tableCard: {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
    overflow: "hidden",
  },
  tableHeader: {
    padding: "15px 18px",
    borderBottom: "1px solid #e5e7eb",
  },
  tableScroll: {
    overflowX: "auto",
    width: "100%",
  },
  table: {
    width: "100%",
    minWidth: "1900px",
    borderCollapse: "collapse",
  },
  th: {
    background: "#111827",
    color: "#ffffff",
    fontSize: "11px",
    fontWeight: 800,
    padding: "11px 10px",
    textAlign: "left",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "10px",
    fontSize: "12px",
    color: "#334155",
    borderBottom: "1px solid #e5e7eb",
    whiteSpace: "nowrap",
  },
  rightTd: {
    padding: "10px",
    fontSize: "12px",
    color: "#334155",
    borderBottom: "1px solid #e5e7eb",
    whiteSpace: "nowrap",
    textAlign: "right",
  },
  netTd: {
    padding: "10px",
    fontSize: "12px",
    borderBottom: "1px solid #e5e7eb",
    whiteSpace: "nowrap",
    textAlign: "right",
    fontWeight: 800,
    color: "#15803d",
  },
  emptyRow: {
    textAlign: "center",
    padding: "36px",
    color: "#64748b",
    fontWeight: 700,
  },
  paginationCard: {
    marginTop: "12px",
    padding: "12px 14px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
  },
  pageInfo: {
    fontSize: "13px",
    color: "#475569",
  },
  pageControls: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  smallSelect: {
    height: "32px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    padding: "0 9px",
    fontSize: "12px",
    background: "#ffffff",
  },
  loaderCard: {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
    padding: "48px 20px",
    textAlign: "center",
  },
  spinner: {
    width: "42px",
    height: "42px",
    margin: "0 auto",
    border: "4px solid #dbeafe",
    borderTopColor: "#2563eb",
    borderRadius: "50%",
    animation: "paymentSpin 0.85s linear infinite",
  },
};

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 36,
    height: 36,
    borderRadius: 9,
    borderColor: state.isFocused ? "#2563eb" : "#d1d5db",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(37, 99, 235, 0.12)" : "none",
    fontSize: 13,
  }),
  valueContainer: (base) => ({
    ...base,
    height: 36,
    padding: "0 9px",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 36,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

const btn = (type = "light") => {
  const base = {
    height: "32px",
    padding: "0 13px",
    borderRadius: "8px",
    border: "1px solid transparent",
    fontSize: "12px",
    fontWeight: 700,
    cursor: "pointer",
    transition: "0.2s ease",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  };

  if (type === "primary") {
    return {
      ...base,
      background: "#2563eb",
      color: "#ffffff",
      boxShadow: "0 3px 8px rgba(37, 99, 235, 0.18)",
    };
  }

  if (type === "success") {
    return {
      ...base,
      background: "#16a34a",
      color: "#ffffff",
      boxShadow: "0 3px 8px rgba(22, 163, 74, 0.18)",
    };
  }

  return {
    ...base,
    background: "#f8fafc",
    color: "#334155",
    borderColor: "#e2e8f0",
  };
};

const disabledBtn = {
  opacity: 0.55,
  cursor: "not-allowed",
};

export default function Employeepaymentreport() {
  const [allPayments, setAllPayments] = useState([]);
  const [searchResults, setSearchResults] = useState([]);

  const [empnos, setEmpnos] = useState([]);
  const [months, setMonths] = useState([]);
  const [years, setYears] = useState([]);
  const [active, setActive] = useState([]);

  const [selectedEmployeeNo, setSelectedEmployeeNo] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedActive, setSelectedActive] = useState("");

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async () => {
    setLoading(true);
    setErrorMessage("");

    try {
      const token = Cookies.get("token");

      const res = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const payments = Array.isArray(res.data) ? res.data : [];

      setAllPayments(payments);
      setSearchResults(payments);

      const empSet = new Set();
      const monthSet = new Set();
      const yearSet = new Set();
      const typeSet = new Set();

      payments.forEach((payment) => {
        if (payment.empNo) empSet.add(payment.empNo);
        if (payment.uploadMonth) monthSet.add(payment.uploadMonth);
        if (payment.uploadYear) yearSet.add(payment.uploadYear);
        if (payment.paymentType) typeSet.add(payment.paymentType);
      });

      const sortedEmpnos = Array.from(empSet).sort((a, b) => {
        if (!isNaN(a) && !isNaN(b)) return Number(a) - Number(b);
        return String(a).localeCompare(String(b));
      });

      setEmpnos(sortedEmpnos.map((empNo) => ({ value: empNo, label: empNo })));

      setMonths(
        Array.from(monthSet).sort(
          (a, b) => monthOrder.indexOf(a) - monthOrder.indexOf(b),
        ),
      );

      setYears(Array.from(yearSet).sort((a, b) => Number(b) - Number(a)));
      setActive(Array.from(typeSet));
      setCurrentPage(1);
    } catch (error) {
      console.log(error);
      setErrorMessage("Unable to load employee payment report.");
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = () => {
    let filtered = [...allPayments];

    if (selectedEmployeeNo) {
      filtered = filtered.filter((item) => item.empNo === selectedEmployeeNo);
    }

    if (selectedMonth) {
      filtered = filtered.filter((item) => item.uploadMonth === selectedMonth);
    }

    if (selectedYear) {
      filtered = filtered.filter(
        (item) => String(item.uploadYear) === String(selectedYear),
      );
    }

    if (selectedActive) {
      filtered = filtered.filter((item) => item.paymentType === selectedActive);
    }

    setSearchResults(filtered);
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setSelectedEmployeeNo("");
    setSelectedMonth("");
    setSelectedYear("");
    setSelectedActive("");
    setSearchResults(allPayments);
    setCurrentPage(1);
  };

  const visibleResults = useMemo(
    () => searchResults.filter((item) => item.paymentType !== "Intermediate"),
    [searchResults],
  );

  const totalRecords = visibleResults.length;
  const totalPages = Math.max(1, Math.ceil(totalRecords / rowsPerPage));

  const paginatedResults = useMemo(() => {
    const start = (currentPage - 1) * rowsPerPage;
    return visibleResults.slice(start, start + rowsPerPage);
  }, [visibleResults, currentPage, rowsPerPage]);

  const totalNetSalary = useMemo(() => {
    return visibleResults.reduce((total, item) => {
      const value = Number(String(item.netSalary || "0").replace(/,/g, ""));
      return total + (isNaN(value) ? 0 : value);
    }, 0);
  }, [visibleResults]);

  const GeneratePDF = () => {
    const PDF = new jsPDF("landscape", "px", [400, 220]);
    PDF.setFontSize(7);

    try {
      const filteredResults = searchResults.filter(
        (payment) => payment.paymentType !== "Intermediate",
      );

      filteredResults.forEach((payment, index) => {
        const start = 10;
        const startX = 15;
        const startY = 25;
        const lineHeight = 8;
        const label1X = startX + 15;
        const label2X = startX + 25;
        const valueX = 100;
        const value1X = 140;
        const totalHeight = 25 * lineHeight;
        const uploadMonth = payment.uploadMonth;
        const monthname = uploadMonth;
        const uploadYear = payment.uploadYear;
        const yearMonthText = `${monthname}  ${uploadYear}`;

        if (index !== 0) {
          PDF.addPage();
        }

        PDF.rect(start, startY - 15, 380, totalHeight);
        PDF.setFontSize(16);
        PDF.setFont("Arial");
        PDF.text("Employee Payslip", start + 145, startY - 3);
        PDF.setFontSize(8);
        PDF.setFont("Helvetica");

        PDF.text(`Payment Month`, startX + 12, startY + 1.8 * lineHeight);
        PDF.text(`${yearMonthText}`, valueX + 30, startY + 1.8 * lineHeight);
        PDF.text(`Employee Number`, startX + 12, startY + 3 * lineHeight);
        PDF.text(`${payment.empNo}`, valueX + 30, startY + 3 * lineHeight);
        PDF.text(`Employee NIC`, startX + 12, startY + 4.2 * lineHeight);
        PDF.text(`${payment.nic}`, valueX + 30, startY + 4.2 * lineHeight);

        PDF.text(`Designation`, startX + 190, startY + 1.8 * lineHeight);
        PDF.text(
          `${payment.designation}`,
          valueX + 185,
          startY + 1.8 * lineHeight,
        );
        PDF.text(`Employee Name`, startX + 190, startY + 3 * lineHeight);
        PDF.text(`${payment.fullName}`, valueX + 185, startY + 3 * lineHeight);
        PDF.text(`Work Location`, startX + 190, startY + 4.2 * lineHeight);
        PDF.text(
          `${payment.workLocation}`,
          valueX + 185,
          startY + 4.2 * lineHeight,
        );

        PDF.setLineWidth(0.25);
        PDF.line(startX + 5, startY + 2, startX + 360, startY + 2);
        PDF.line(
          startX + 5,
          startY + 5 * lineHeight,
          startX + 360,
          startY + 5 * lineHeight,
        );

        PDF.setFontSize(10);
        PDF.text(`Earnings`, label1X - 4, startY + 6.5 * lineHeight);
        PDF.setFontSize(8);

        PDF.text(`Basic salary `, label1X, startY + 8 * lineHeight);
        PDF.text(
          `(+ ${payment.salary})`,
          value1X + 20,
          startY + 8 * lineHeight,
          { align: "right" },
        );
        PDF.text(`Bud Allowance `, label1X, startY + 9 * lineHeight);
        PDF.text(
          `(+ ${payment.budAllowance})`,
          value1X + 20,
          startY + 9 * lineHeight,
          { align: "right" },
        );
        PDF.text(`Nopay Amount `, label1X, startY + 10 * lineHeight);
        PDF.text(
          `(- ${payment.nopayAmount})`,
          value1X + 20,
          startY + 10 * lineHeight,
          { align: "right" },
        );
        PDF.text(`Salary Areears `, label1X, startY + 11 * lineHeight);
        PDF.text(
          `(+ ${payment.salaryArrears})`,
          value1X + 20,
          startY + 11 * lineHeight,
          { align: "right" },
        );
        PDF.text(`Gross Salary `, label1X, startY + 12 * lineHeight);
        PDF.text(
          ` ${payment.grossAmount}`,
          value1X + 20,
          startY + 12 * lineHeight,
          { align: "right" },
        );

        PDF.text(`Additions`, label1X, startY + 13.5 * lineHeight);
        PDF.setFontSize(7);
        PDF.text(`OT Allowance`, label2X, startY + 14.5 * lineHeight);
        PDF.text(
          `${payment.overtimeAllowance}`,
          value1X + 20,
          startY + 14.5 * lineHeight,
          { align: "right" },
        );
        PDF.text(`DOT Allowance`, label2X, startY + 15.5 * lineHeight);
        PDF.text(
          `${payment.dotAllowance}`,
          value1X + 20,
          startY + 15.5 * lineHeight,
          { align: "right" },
        );
        PDF.text(`Performance Allowance`, label2X, startY + 16.5 * lineHeight);
        PDF.text(
          `${payment.totalPerformanceAllowance}`,
          value1X + 20,
          startY + 16.5 * lineHeight,
          { align: "right" },
        );
        PDF.text(`Sales Commission`, label2X, startY + 17.5 * lineHeight);
        PDF.text(
          `${payment.salesCommission}`,
          value1X + 20,
          startY + 17.5 * lineHeight,
          { align: "right" },
        );
        PDF.text(`Other Allowance`, label2X, startY + 18.5 * lineHeight);
        PDF.text(
          `${payment.totalotherAllowance}`,
          value1X + 20,
          startY + 18.5 * lineHeight,
          { align: "right" },
        );
        PDF.text(`Total Allowance`, label2X, startY + 19.5 * lineHeight);
        PDF.text(
          `(+ ${payment.totalAllowance})`,
          value1X + 20,
          startY + 19.5 * lineHeight,
          { align: "right" },
        );

        PDF.setFontSize(9);
        PDF.setFont("Helvetica-Bold");
        PDF.text(`Total Earning`, label1X, startY + 21.5 * lineHeight);
        PDF.text(
          `${payment.totalEarning}`,
          value1X + 20,
          startY + 21.5 * lineHeight,
          { align: "right" },
        );

        PDF.setFontSize(10);
        PDF.setFont("Helvetica");
        PDF.text(`Deductions`, label1X + 175, startY + 6.5 * lineHeight);
        PDF.setFontSize(8);
        PDF.text(`Advance Deduction`, label2X + 169, startY + 8 * lineHeight);
        PDF.text(
          `${payment.advanceDeduction}`,
          value1X + 189,
          startY + 8 * lineHeight,
          { align: "right" },
        );
        PDF.text(`EPF(8%)`, label2X + 169, startY + 9 * lineHeight);
        PDF.text(`${payment.epf8}`, value1X + 189, startY + 9 * lineHeight, {
          align: "right",
        });
        PDF.text(`Stamp Duty`, label2X + 169, startY + 10 * lineHeight);
        PDF.text(
          `${payment.stampDuty}`,
          value1X + 189,
          startY + 10 * lineHeight,
          { align: "right" },
        );
        PDF.text(`Tax`, label2X + 169, startY + 11 * lineHeight);
        PDF.text(
          `${payment.payeetax}`,
          value1X + 189,
          startY + 11 * lineHeight,
          { align: "right" },
        );

        PDF.setFontSize(9);
        PDF.setFont("Helvetica-Bold");
        PDF.text(`Total Deduction`, label2X + 169, startY + 17.5 * lineHeight);
        PDF.text(
          `( - ${payment.totalDeduction})`,
          value1X + 189,
          startY + 17.5 * lineHeight,
          { align: "right" },
        );

        PDF.text(`Net Paid`, label1X + 176, startY + 19 * lineHeight);
        PDF.text(
          `${payment.netSalary}`,
          value1X + 189,
          startY + 19 * lineHeight,
          { align: "right" },
        );

        PDF.setLineWidth(0.75);
        PDF.line(
          value1X + 64,
          startY + 19.25 * lineHeight,
          value1X + 189,
          startY + 19.25 * lineHeight,
        );
        PDF.line(
          value1X + 64,
          startY + 19.45 * lineHeight,
          value1X + 189,
          startY + 19.45 * lineHeight,
        );

        PDF.line(
          value1X + 64,
          startY + 18 * lineHeight,
          value1X + 189,
          startY + 18 * lineHeight,
        );

        PDF.setFontSize(8);
        PDF.setFont("Helvetica");
        PDF.text(`EPF (12%)`, label2X + 169, startY + 20.5 * lineHeight);
        PDF.text(
          `${payment.epf12}`,
          value1X + 189,
          startY + 20.5 * lineHeight,
          { align: "right" },
        );
        PDF.text(`ETF`, label2X + 169, startY + 21.5 * lineHeight);
        PDF.text(`${payment.etf3}`, value1X + 189, startY + 21.5 * lineHeight, {
          align: "right",
        });

        PDF.save(`${payment.fullName}_${yearMonthText}_Payment_Report.pdf`);
      });
    } catch (error) {
      console.error("Error generating pay slip:", error);
    }
  };
  return (
    <div style={styles.page}>
      <style>
        {`
          @keyframes paymentSpin {
            to { transform: rotate(360deg); }
          }

          @media (max-width: 1200px) {
            .payment-summary-grid, .payment-filter-grid {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            .payment-topbar {
              align-items: flex-start !important;
              flex-direction: column !important;
            }
          }

          @media (max-width: 768px) {
            .payment-content {
              margin-left: 0 !important;
              width: 100% !important;
              padding: 14px !important;
            }
            .payment-summary-grid, .payment-filter-grid {
              grid-template-columns: 1fr !important;
            }
            .payment-pagination {
              flex-direction: column !important;
              align-items: flex-start !important;
              gap: 10px !important;
            }
            .payment-page-controls {
              flex-wrap: wrap !important;
            }
          }
        `}
      </style>

      <Sidebar />

      <main style={styles.content} className="payment-content">
        <section style={styles.topbar} className="payment-topbar">
          <div>
            <h1 style={styles.title}>Employee Monthly Payment Report</h1>
            <p style={styles.subtitle}>
              View, filter, paginate and export monthly payment records.
            </p>
          </div>

          <div style={styles.actionGroup}>
            <button
              style={{ ...btn("light"), ...(loading ? disabledBtn : {}) }}
              onClick={fetchPayments}
              disabled={loading}
            >
              Refresh
            </button>

            <button
              style={{
                ...btn("success"),
                ...(loading || totalRecords === 0 ? disabledBtn : {}),
              }}
              onClick={GeneratePDF}
              disabled={loading || totalRecords === 0}
            >
              Generate PDF
            </button>
          </div>
        </section>

        <section style={styles.summaryGrid} className="payment-summary-grid">
          <div style={styles.summaryCard}>
            <span style={styles.summaryLabel}>Total Records</span>
            <strong style={styles.summaryValue}>{totalRecords}</strong>
          </div>

          <div style={styles.summaryCard}>
            <span style={styles.summaryLabel}>Employees</span>
            <strong style={styles.summaryValue}>{empnos.length}</strong>
          </div>

          <div style={styles.summaryCard}>
            <span style={styles.summaryLabel}>Months</span>
            <strong style={styles.summaryValue}>{months.length}</strong>
          </div>

          <div style={styles.summaryCard}>
            <span style={styles.summaryLabel}>Total Net Salary</span>
            <strong style={styles.summaryValue}>
              {totalNetSalary.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </strong>
          </div>
        </section>

        <section style={styles.filterCard}>
          <div style={styles.filterHeader}>
            <div>
              <h2 style={styles.sectionTitle}>Filters</h2>
              <p style={styles.sectionSub}>
                Select required details and apply filters.
              </p>
            </div>
          </div>

          <div style={styles.filterGrid} className="payment-filter-grid">
            <div style={styles.field}>
              <label style={styles.label}>Employee No</label>
              <Select
                value={
                  empnos.find(
                    (option) => option.value === selectedEmployeeNo,
                  ) || null
                }
                options={empnos}
                isClearable
                isSearchable
                onChange={(option) =>
                  setSelectedEmployeeNo(option ? option.value : "")
                }
                placeholder="Select employee"
                styles={selectStyles}
              />
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Month</label>
              <select
                style={styles.select}
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                <option value="">All Months</option>
                {months.map((month) => (
                  <option key={month} value={month}>
                    {month}
                  </option>
                ))}
              </select>
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Year</label>
              <select
                style={styles.select}
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                <option value="">All Years</option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Payment Type</label>
              <select
                style={styles.select}
                value={selectedActive}
                onChange={(e) => setSelectedActive(e.target.value)}
              >
                <option value="">All Types</option>
                {active.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div style={styles.filterActions}>
            <button
              style={{ ...btn("primary"), ...(loading ? disabledBtn : {}) }}
              onClick={handleFilter}
              disabled={loading}
            >
              Apply
            </button>

            <button
              style={{ ...btn("light"), ...(loading ? disabledBtn : {}) }}
              onClick={clearFilters}
              disabled={loading}
            >
              Clear
            </button>
          </div>
        </section>

        {loading ? (
          <section style={styles.loaderCard}>
            <div style={styles.spinner} />
            <h3 style={{ margin: "12px 0 5px", fontSize: "16px" }}>
              Loading report
            </h3>
            <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>
              Please wait while payment records are loading.
            </p>
          </section>
        ) : errorMessage ? (
          <section style={styles.loaderCard}>
            <h3 style={{ margin: "0 0 12px", fontSize: "16px" }}>
              {errorMessage}
            </h3>
            <button style={btn("primary")} onClick={fetchPayments}>
              Try Again
            </button>
          </section>
        ) : (
          <>
            <section style={styles.tableCard}>
              <div style={styles.tableHeader}>
                <h2 style={styles.sectionTitle}>Payment Details</h2>
                <p style={styles.sectionSub}>
                  Showing {paginatedResults.length} of {totalRecords} records
                </p>
              </div>

              <div style={styles.tableScroll}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      {columns.map((col) => (
                        <th key={col[0]} style={styles.th}>
                          {col[1]}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {paginatedResults.length > 0 ? (
                      paginatedResults.map((payment, index) => (
                        <tr
                          key={payment.id || `${payment.empNo}-${index}`}
                          style={{
                            background: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                          }}
                        >
                          {columns.map((col) => {
                            const isRight = ![
                              "empNo",
                              "epfNo",
                              "fullName",
                            ].includes(col[0]);
                            const isNet = col[0] === "netSalary";

                            return (
                              <td
                                key={col[0]}
                                style={
                                  isNet
                                    ? styles.netTd
                                    : isRight
                                      ? styles.rightTd
                                      : styles.td
                                }
                              >
                                {payment[col[0]] ?? "-"}
                              </td>
                            );
                          })}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={columns.length} style={styles.emptyRow}>
                          No payment records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </section>

            <section
              style={styles.paginationCard}
              className="payment-pagination"
            >
              <div style={styles.pageInfo}>
                Page <strong>{currentPage}</strong> of{" "}
                <strong>{totalPages}</strong>
              </div>

              <div
                style={styles.pageControls}
                className="payment-page-controls"
              >
                <select
                  style={styles.smallSelect}
                  value={rowsPerPage}
                  onChange={(e) => {
                    setRowsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  <option value={10}>10 rows</option>
                  <option value={25}>25 rows</option>
                  <option value={50}>50 rows</option>
                  <option value={100}>100 rows</option>
                </select>

                <button
                  style={{
                    ...btn("light"),
                    ...(currentPage === 1 ? disabledBtn : {}),
                  }}
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(1)}
                >
                  First
                </button>

                <button
                  style={{
                    ...btn("light"),
                    ...(currentPage === 1 ? disabledBtn : {}),
                  }}
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                >
                  Prev
                </button>

                <button
                  style={{
                    ...btn("primary"),
                    ...(currentPage === totalPages ? disabledBtn : {}),
                  }}
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                >
                  Next
                </button>

                <button
                  style={{
                    ...btn("light"),
                    ...(currentPage === totalPages ? disabledBtn : {}),
                  }}
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(totalPages)}
                >
                  Last
                </button>
              </div>
            </section>
          </>
        )}
      </main>
    </div>
  );
}
